import { useEffect } from "react";
import { Navbar } from "@/components/sps/Navbar";
import { Contact } from "@/components/sps/Contact";
import { Footer } from "@/components/sps/Footer";

export default function ContactoPage() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="App grain min-h-screen bg-[#001825] text-[#f8f9fa] relative">
      <Navbar />
      <main className="relative z-[2] pt-24 md:pt-28">
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
